module.exports = __webpack_public_path__ + "static/img/areaA-25.07659fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-25.png
// module id = 946
// module chunks = 1